module.exports = "/images/desert.jpg?cf22270d24894e2d6b4c9f1d83d8264d";